export function isHTMLElement(input) {
  return input instanceof HTMLElement;
}
